import React from 'react';
const steps = ['heutiges Thema', 'Ziel der Stunde', 'Material', 'Aufwärmung', 'Hauptteil', 'Varianten', 'Abschlussfrage'];
export function ImagineSection() {
  return <section className="w-full bg-bg-dark py-16 sm:py-24 px-4" data-id="element-156">
      <div className="max-w-3xl mx-auto text-center" data-id="element-157">
        <h2 className="text-3xl sm:text-5xl font-serif font-black text-text-main mb-4" data-id="element-158">
          Stell dir vor…
        </h2>
        <p className="text-text-sec text-base sm:text-lg font-medium mb-10" data-id="element-159">
          Du öffnest morgens dein PDF und siehst sofort:
        </p>

        <div className="bg-bg-alt rounded-3xl border border-border-light shadow-sm p-6 sm:p-8 max-w-xl mx-auto mb-10" data-id="element-160">
          <ul className="space-y-3 text-left" data-id="element-161">
            {steps.map((step, i) => <li key={i} className="flex items-center gap-3 text-text-main font-medium text-base sm:text-lg" data-id="element-162">
                <span className="w-7 h-7 rounded-full bg-primary text-white flex items-center justify-center font-serif font-black text-sm flex-shrink-0" data-id="element-163">
                  {i + 1}
                </span>
                <span data-id="element-164">{step}</span>
              </li>)}
          </ul>
        </div>

        <p className="text-text-sec text-base sm:text-lg font-medium max-w-2xl mx-auto mb-3" data-id="element-165">
          Du musst nichts mehr von null planen. Du gehst in die Sporthalle und
          weißt genau, was du machst.
        </p>
        <p className="text-primary font-serif italic text-xl sm:text-2xl font-bold" data-id="element-166">
          Das ist der Unterschied zwischen Improvisation und Sicherheit.
        </p>
      </div>
    </section>;
}